import { getProxyUrl } from '.'

export async function deleteVersion(idVersiones: number, navigate: any) {
  const url = getProxyUrl('api/diseno/borrarversion/')
  const idVers = JSON.stringify(idVersiones)
  const params = {
    idVers: idVers,
    method: 'GET',
    mode: 'cors',
    headers: {
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const data = await fetch(url + `${idVersiones}`, params as RequestInit)
    if (data.status === 200) {
      if (window.location.pathname === `/planner/deleteProyect/${idVers}`) {
        navigate('/planner/proyectos')
      } else navigate('/planner/proyectos')
    } else {
      return
    }
  } catch (e: any) {}
}
